<template>
  <div>
    <nav-dropdown
      ref="navDropdown"
      :items="brands"
      class="NewsroomsDropdown"
      has-arrow
      min-width="250px"
    >
      <a
        slot="trigger"
        slot-scope="{ toggle }"
        class="cursor-pointer px-4 py-3 text-base text-white/80 transition-colors hover:text-white md:px-3 md:py-2 md:text-sm"
        @click="toggle"
      >
        {{ $t('components.newsrooms_dropdown.trigger_text') }}
      </a>
      <div
        slot-scope="{ item: brand }"
        class="flex items-center text-white"
      >
        <router-link
          v-if="brand.newsrooms.length"
          :to="{ name: 'newsroom.edit', params: { newsroomSlug: brand.newsrooms[0].slug } }"
          class="mr-auto normal-case"
          active-class="text-brand"
        >
          {{ brand.name }}
        </router-link>
        <span v-else class="mr-auto">{{ brand.name }}</span>
        <router-link
          v-for="newsroom in brand.newsrooms"
          :key="newsroom.id"
          :to="{ name: 'newsroom.edit', params: { newsroomSlug: newsroom.slug } }"
          class="ml-2 normal-case"
          active-class="text-brand"
        >
          <country-flag :country="newsroom.country.iso_alpha2" />
        </router-link>
      </div>
    </nav-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import NavDropdown from '@/shared/js/components/core/NavDropdown'

/**
 * @module NewsroomsDropdown
 */
export default {
  name: 'NewsroomsDropdown',
  components: { NavDropdown },

  computed: {
    ...mapGetters(['brands'])
  },

  watch: {
    '$route.fullPath': function () {
      this.$refs.navDropdown.closeMenu()
    }
  }
}
</script>
